import { render, staticRenderFns } from "./RatingScale.vue?vue&type=template&id=a6b1bd74&scoped=true"
import script from "./RatingScale.vue?vue&type=script&lang=js"
export * from "./RatingScale.vue?vue&type=script&lang=js"
import style0 from "./RatingScale.vue?vue&type=style&index=0&id=a6b1bd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1bd74",
  null
  
)

export default component.exports